// On click scroll
document
  .querySelectorAll(".infinite-slider .js-collection-item a")
  .forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const targetTitle = this.getAttribute("title");
      const targetBlock = document.getElementById(targetTitle);

      if (targetBlock) {
        targetBlock.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });

// Infinite Slider
$(document).ready(function () {
  $(".infinite-slider").slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: false,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  });
});
